// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-view{margin-top:30px}.table-view__header{display:flex;flex:1 1 auto;justify-content:flex-end;margin-bottom:20px}.table-view .dynamic-table-column-header{text-align:left !important}.table-view .dynamic-table__row-column{text-align:left !important}@media only screen and (max-width: 720px){.table-view__dynamic-label{display:none}.table-view__dynamic-value{display:none}}", ""]);
// Exports
module.exports = exports;
